import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';

function SNSUrlEditModal({ open, onClose, snsInfo, onSuccess }) {
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open && snsInfo) {
      setUrl(snsInfo.url || '');
      setError('');
    }
  }, [open, snsInfo]);

  const handleSubmit = async () => {
    if (!snsInfo) return;
    if (!url.trim()) { setError('URL을 입력해주세요.'); return; }

    setError('');
    setLoading(true);
    try {
      const res = await fetch(
        `${API_URL}/api/admin/influencer/info/sns/${snsInfo._id}/url`,
        {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ url })
        }
      );
      const data = await res.json();
      if (data.ok) {
        onSuccess && onSuccess();
        onClose();
      } else {
        setError(data.message || 'URL 수정에 실패했습니다.');
      }
    } catch {
      setError('URL 수정 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div className="influencer-info-edit-modal" onClick={onClose}>
      <div className="influencer-info-edit-modal__content" onClick={(e) => e.stopPropagation()}>
        <h3 className="influencer-info-edit-modal__title">SNS URL 수정</h3>

        {snsInfo && (
          <div className="influencer-info-edit-modal__checkbox-wrapper">
            <div className="influencer-info-edit-modal__sns-info">
              <div className="influencer-info-edit-modal__sns-info-row">
                플랫폼: <strong>{snsInfo.platform}</strong>
              </div>
              <div className="influencer-info-edit-modal__sns-info-row">
                계정명: <strong>{snsInfo.accountName}</strong>
              </div>
            </div>
            <div>
              <label className="influencer-info-edit-modal__label">URL</label>
              <input
                type="text"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                placeholder="https://..."
                className="influencer-info-edit-modal__number-input"
                style={{ width: '100%' }}
              />
            </div>
          </div>
        )}

        {error && <div className="influencer-info-edit-modal__error">{error}</div>}

        <div className="influencer-info-edit-modal__actions">
          <button
            onClick={onClose}
            disabled={loading}
            className="influencer-info-edit-modal__button influencer-info-edit-modal__button--cancel"
          >
            취소
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="influencer-info-edit-modal__button influencer-info-edit-modal__button--submit"
          >
            {loading ? '처리 중...' : '수정'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SNSUrlEditModal;
